export default {
  OK: 200,
  Created: 201,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500,
  ServerMaintain: 503,
  BusinessError: 550,
}
